import { FlattenedFilterState } from '@sls-react/typings/services/rails/facets';

export default function getTransferableFilterState(
  evaluatedFilterState: FlattenedFilterState,
  defaultSort = 'default',
) {
  const {
    category,
    sort,
    state,
    id,
    saved_search_id,
    close_to,
    ...filterState
  } = evaluatedFilterState;

  const newFilterState = {
    ...filterState,
  };

  if (sort !== defaultSort) {
    newFilterState.sort = sort;
  }

  if (!state?.includes('available')) {
    newFilterState.state = state;
  }

  return newFilterState;
}
